import axios from "axios";
import store from "@/store";

class CUG {
  // Get token and uuid from store
  authToken() {
    return `Bearer ${store.getters["auth/getToken"]}`;
  }

  authRefreshToken() {
    return store.getters["auth/getRefreshToken"];
  }

  authUuid() {
    return store.getters["auth/getUuid"];
  }

  currentCustomerId() {
    return store.getters["auth/getCurrentCustomerId"];
  }

  cartUuid() {
    return store.getters["cart/getUuid"];
  }

  // Tenant
  whoami() {
    return axios({
      url: `${this.baseUrl()}/whoami.json`,
      method: "GET"
    });
  }

  text(type = 'text_rules_of_procedures', lang = 'fr') {
    return axios({
      url: `${this.baseUrl()}/${type}.json`,
      params: { lang },
      method: "GET"
    });
  }

  // Emailing
  subscribeToNewsletter(data) {
    return axios({
      url: `${this.baseUrl()}/emailing/subscribe.json`,
      data: data,
      method: "POST"
    });
  }


  // Authentification
  login(data) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/sign_in.json`,
      data: data,
      method: "POST"
    });
  }

  refresh() {
    return axios({
      url: `${this.baseUrl()}/online_accounts/refresh_token.json`,
      data: {
        uuid: this.authUuid(),
        refresh_token: this.authRefreshToken()
      },
      method: "PUT"
    });
  }

  signUp(data) {
    return axios({
      url: `${this.baseUrl()}/online_accounts.json`,
      data: { online_account: data },
      method: "POST"
    });
  }

  resetPassword(data) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/reset_passwords.json`,
      data: data,
      method: "POST"
    });
  }

  newPassword(data) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/reset_passwords.json`,
      data: data,
      method: "PUT"
    });
  }

  createAccountFromInvitation(data) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/create_from_invitation.json`,
      data: data,
      method: "POST"
    });
  }

  // get online account
  getAccount() {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  updateAccount(data) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}.json`,
      headers: { Authorization: this.authToken() },
      data: data,
      method: "PUT"
    });
  }

  deleteAccount() {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}.json`,
      headers: { Authorization: this.authToken() },
      method: "DELETE"
    });
  }

  // get customer in account
  getCustomer() {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  updateCustomer(data) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}.json`,
      headers: { Authorization: this.authToken() },
      data: {
        customer: data
      },
      method: "PUT"
    });
  }

  getCards() {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/cards.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  getReusableCards() {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/cards/reusables.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  getCard(cardId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/cards/${cardId}.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  getPdfPurchase(purchaseId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/purchases/${purchaseId}.pdf`,
      headers: { Authorization: this.authToken() },
      responseType: 'blob',
      method: "GET"
    });
  }

  getPdfContract(plannedStageId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/planned_stages/${plannedStageId}/contract.pdf`,
      headers: { Authorization: this.authToken() },
      responseType: 'blob',
      method: "GET"
    });
  }

  getPlannedStageDates(plannedStageId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/planned_stages/${plannedStageId}/dates.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  getCardAccesses() {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/card_accesses.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  cancelCardAccess(cardAccessId, reason) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/card_accesses/${cardAccessId}/cancel.json`,
      headers: { Authorization: this.authToken() },
      data: {
        deactivation_reason_type: reason
      },
      method: "DELETE"
    });
  }

  getCardAccessPurchases(cardAccessId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/card_accesses/${cardAccessId}/purchase_lines.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  // Customer booking
  getBookings () {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/bookings.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  getPlannedLessonPurchases(plannedLessonId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/planned_lessons/${plannedLessonId}/purchase_lines.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  getPlannedActivityPurchases(plannedActivityId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/planned_activities/${plannedActivityId}/purchase_lines.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  getPlannedStagePurchases(plannedStageId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/planned_stages/${plannedStageId}/purchase_lines.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  // Customer MultiTickets
  getMultiTickets () {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/multi_tickets_books.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  // Packs

  getPack (packId) {
    return axios({
      url: `${this.baseUrl()}/packs/${packId}.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  addPackToCard (data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/packs.json`,
      data: data,
      method: "POST"
    });
  }

  // Documents
  getDocuments () {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/documents.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  getSaleContracts () {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/documents/sale_contracts.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  // Purchases
  getPurchases () {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/purchases.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  // Notifications
  getNotifications () {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/notifications.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  countUnreadNotifications () {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/notifications/unread_count.json`,
      headers: { Authorization: this.authToken() },
      method: "GET"
    });
  }

  readNotifications (notificationId) {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/notifications/${notificationId}/read.json`,
      headers: { Authorization: this.authToken() },
      method: "PUT"
    });
  }

  readAllNotifications () {
    return axios({
      url: `${this.baseUrl()}/online_accounts/${this.authUuid()}/customers/${this.currentCustomerId()}/notifications/read_all.json`,
      headers: { Authorization: this.authToken() },
      method: "PUT"
    });
  }

  // Recruitment
  recruitmentPostList() {
    return axios({
      url: `${this.baseUrl()}/recruitments/posts.json`,
      method: "GET"
    });
  }

  recruitmentPostDomains(params) {
    return axios({
      url: `${this.baseUrl()}/recruitments/posts/domains.json`,
      method: "GET",
      params
    });
  }

  recruitmentPost(data) {
    return axios({
      url: `${this.baseUrl()}/recruitments/posts/${data.id}.json`,
      method: "GET"
    });
  }

  applyForJob(data) {
    return axios({
      url: `${this.baseUrl()}/recruitments/post_candidates.json`,
      data: data,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  // Lessons
  availableLessons() {
    return axios({
      url: `${this.baseUrl()}/lessons/available_online.json`,
      method: "GET"
    });
  }

  monthlyLessons(data) {
    return axios({
      url: `${this.baseUrl()}/lessons.json`,
      params: data,
      method: "GET"
    });
  }

  monthlyFullLessons(data) {
    return axios({
      url: `${this.baseUrl()}/lessons/full.json`,
      params: data,
      method: "GET"
    });
  }

  dailyLessons(data) {
    return axios({
      url: `${this.baseUrl()}/planned_lessons.json`,
      params: data,
      method: "GET"
    });
  }

  getLesson(data) {
    return axios({
      url: `${this.baseUrl()}/lessons/${data.id}.json`,
      method: "GET"
    });
  }

  addPlannedLessonToCard(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/planned_lessons.json`,
      data: data,
      method: "POST"
    });
  }

  // Lesson Participant
  createLessonParticipantByTicket (data) {
    return axios({
      url: `${this.baseUrl()}/planned_lesson_participants/create_by_ticket_barcode.json`,
      data: data,
      method: "POST"
    });
  }

  registerLessonParticipant (data) {
    return axios({
      url: `${this.baseUrl()}/planned_lesson_participants/register.json`,
      data: data,
      method: "POST"
    });
  }

  // Product tree
  productTree(productTreeId) {
    return axios({
      url: `${this.baseUrl()}/product_trees/${productTreeId}.json`,
      method: "GET"
    });
  }

  // Activity
  availableActivities() {
    return axios({
      url: `${this.baseUrl()}/activities/available_online.json`,
      method: "GET"
    });
  }

  monthlyActivities(data) {
    return axios({
      url: `${this.baseUrl()}/activities.json`,
      params: data,
      method: "GET"
    });
  }

  monthlyFullActivities(data) {
    return axios({
      url: `${this.baseUrl()}/activities/full.json`,
      params: data,
      method: "GET"
    });
  }

  dailyActivities(data) {
    return axios({
      url: `${this.baseUrl()}/planned_activities.json`,
      params: data,
      method: "GET"
    });
  }

  addPlannedActivityToCard(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/planned_activity_dates.json`,
      data: data,
      method: "POST"
    });
  }

  // Multi Tickets Book Barcodes
  usableBarcodes(data) {
    return axios({
      url: `${this.baseUrl()}/multi_tickets_book_barcodes/usable.json`,
      params: data,
      method: "GET"
    });
  }

  // Stages planner
  getCustomerLevels(data) {
    return axios({
      url: `${this.baseUrl()}/stages/customers_levels.json`,
      method: "POST",
      data: data
    });
  }

  getRegistrationStages(data) {
    return axios({
      url: `${this.baseUrl()}/stages/re_registration_planned_stages.json`,
      method: "POST",
      data: data
    });
  }

  getAvailableStages(data) {
    return axios({
      url: `${this.baseUrl()}/stages/planned_stages.json`,
      method: "POST",
      data: data
    });
  }

  addPlannedStagesToCard(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/planned_stages.json`,
      data: data,
      method: "POST"
    });
  }

  // Activity products
  getActivityProduct(data) {
    return axios({
      url: `${this.baseUrl()}/activity_products/${data.id}.json`,
      method: "GET"
    });
  }

  // Activity products
  getActivity(data) {
    return axios({
      url: `${this.baseUrl()}/activities/${data.id}.json`,
      method: "GET"
    });
  }

  // Activity Participant
  createActivityParticipantByTicket (data) {
    return axios({
      url: `${this.baseUrl()}/planned_activity_participants/create_by_ticket_barcode.json`,
      data: data,
      method: "POST"
    });
  }


  registerActivityParticipant (data) {
    return axios({
      url: `${this.baseUrl()}/planned_activity_participants/register.json`,
      data: data,
      method: "POST"
    });
  }

  // Private Lesson
  getPrivateLesson(data) {
    return axios({
      url: `${this.baseUrl()}/private_lessons/${data.id}.json`,
      method: "GET"
    });
  }

  // Stage
  getStage(data) {
    return axios({
      url: `${this.baseUrl()}/stages/${data.id}.json`,
      method: "GET"
    });
  }

  // Subscription
  getSubscription(data) {
    return axios({
      url: `${this.baseUrl()}/subscriptions/${data.id}.json`,
      method: "GET"
    });
  }

  addSubscriptionToCard(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/subscriptions.json`,
      data: data,
      method: "POST"
    });
  }

  // Unlimited Subscription
  getUnlimitedSubscription(data) {
    return axios({
      url: `${this.baseUrl()}/unlimited_subscriptions/${data.id}.json`,
      method: "GET"
    });
  }

  getUnlimitedSubscriptionDeactivationReasons() {
    return axios({
      url: `${this.baseUrl()}/unlimited_subscriptions/deactivation_reasons.json`,
      method: "GET"
    });
  }

  addUnlimitedSubscriptionToCard(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/unlimited_subscriptions.json`,
      data: data,
      method: "POST"
    });
  }

  // Multi tickets books
  getMultiTicketsBook(data) {
    return axios({
      url: `${this.baseUrl()}/multi_tickets_books/${data.id}.json`,
      method: "GET"
    });
  }

  // Tickets book
  getTicketsBook(data) {
    return axios({
      url: `${this.baseUrl()}/tickets_books/${data.id}.json`,
      method: "GET"
    });
  }

  addTicketsBookToCard(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/tickets_books.json`,
      data: data,
      method: "POST"
    });
  }

  addMultiTicketsBookToCard(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/multi_tickets_books.json`,
      data: data,
      method: "POST"
    });
  }

  // Products
  getProduct(data) {
    return axios({
      url: `${this.baseUrl()}/products/${data.id}.json`,
      method: "GET"
    });
  }

  addProductToCard(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/products.json`,
      data: data,
      method: "POST"
    });
  }

  // Cart
  cartExist() {
    return axios({
      url: `${this.baseUrl()}/carts/exist.json`,
      params: { uuid: this.cartUuid() },
      method: "GET"
    });
  }

  getCart() {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}.json`,
      method: "GET"
    });
  }

  getCartItem (uuidItem) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/items/${uuidItem}.json`,
      method: "GET"
    });
  }

  createCart() {
    return axios({
      url: `${this.baseUrl()}/carts.json`,
      method: "POST"
    });
  }

  deleteCart() {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}.json`,
      method: "DELETE"
    });
  }

  updateCartItem (data, uuidItem, uuidContainer = null) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/items/${uuidItem}.json`,
      method: "PUT",
      data: data,
      params: {
        container: uuidContainer
      }
    });
  }

  updateCartPack (data, uuidItem) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/packs/${uuidItem}.json`,
      method: "PUT",
      data: data
    });
  }

  deleteCartItem(uuidItem) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/items/${uuidItem}.json`,
      method: "DELETE"
    });
  }

  addCartPromotion(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/promotions.json`,
      data: data,
      method: "POST"
    });
  }

  deleteCartPromotion(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/promotions.json`,
      data: data,
      method: "DELETE"
    });
  }

  checkoutCart(data) {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/checkout.json`,
      data: data,
      method: "POST"
    });
  }

  getCartSuggestion() {
    return axios({
      url: `${this.baseUrl()}/carts/${this.cartUuid()}/suggestions.json`,
      method: "GET"
    });
  }

  baseUrl() {
    return window.__osvConf.baseUrl;
  }
}

export default new CUG();
